import { useContext } from "react";
import { useIsVisibleModal } from "./useIsVisibleModal";
import { RulesPermissionUserContext } from "../contexts/RulesPermissionUser";

export const useFunctionPopUp = () => {
    const {isVisibleModal, setIsVisibleModal} = useIsVisibleModal();
    const {isVisibleModal: isVisibleModalSupply, setIsVisibleModal: setIsVisibleModalSupply} = useIsVisibleModal();
    const {findIdRulesPermission} = useContext(RulesPermissionUserContext)

    const openModalSangria = () => {
        if(!findIdRulesPermission('4.7.1')) return;
        setIsVisibleModal(true)
    }
    
    const closeModalSangria = () => setIsVisibleModal(false);
    
    const openModalSupply = () => {
        if(!findIdRulesPermission('4.7.2')) return;
        setIsVisibleModalSupply(true)
    }

    const closeModalSupply = () => setIsVisibleModalSupply(false);

    return{
        isVisibleModal, setIsVisibleModal, isVisibleModalSupply,setIsVisibleModalSupply,
        openModalSangria, closeModalSangria, openModalSupply, closeModalSupply
    }
}